import React from "react";
import { PolicyIcon } from "./PolicyIcon";
import pdfDownloadBtn from "assets/icons/pdfDownloadBtn.svg";
import { AiFillCopy } from "react-icons/ai";
interface PolicyCardProps {
  policy: any;
  className?: string;
}
const DuplicateIcon = () => {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 text-amber-800 px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ring-amber-200">
      <AiFillCopy className="h-3 w-3" />
      Duplicate
    </span>
  );
};

export const PolicyCard: React.FC<PolicyCardProps> = ({ policy, className = "" }) => {
  const getBorderColorByType = () => {
    switch (policy?.policyTypeId?.name) {
      case "Health Insurance":
        return "border-[#CEE2D4] bg-[#F1F8F5]";
      case "Life Insurance":
        return "border-[#E9D6D4] bg-[#FCEEED]";
      case "Motor Insurance":
        return "border-[#C1DDED] bg-[#ECF2F6]";
      default:
        return "border-[#C0C0C0] bg-[#E5E4E2]";
    }
  };
  const cardTextStyl = "sm:text-sm text-[12px] font-bold text-gray-900  md:max-w-full min-w-56 mr-4";
  const textStyle = "sm:text-sm text-[13px] font-medium text-gray-500 md:max-w-full max-w-40";

  return (
    <>
      <div className={`rounded-xl rounded-tr-none border-2 cursor-pointer ${getBorderColorByType()} overflow-hidden transition-all duration-300 hover:shadow-md ${className}`}>
        <div className="p-2">
          <div className="flex items-center space-x-4">
            <PolicyIcon type={policy.policyTypeId?.name} />
            <div className="flex h-full items-center">
              <p className=" font-bold text-gray-800 flex lg:text-[1rem] sm:text-sm text-[12px]">{policy?.insuranceCompanyId?.name || "-----"}</p>
            </div>
            {policy?.isDuplicateRequest && <DuplicateIcon />}
          </div>
        </div>
        <div className="w-full border-t border-dashed border-gray-300 "></div>

        <div className="grid grid-cols-3 gap-[120px] px-2 py-2 md:px-3 lg:px-4">
          <div>
            <h4 className={cardTextStyl}>Policy Holder Name</h4>
            <p className={`${textStyle} min-w-28 md:min-w-52`}>{policy?.owner?.name || "-----"}</p>
          </div>
          <div>
            <h4 className={cardTextStyl}>Policy Number</h4>
            <p className={`${textStyle} truncate min-w-28 md:min-w-52`}>{policy?.policyNumber || "-----"}</p>
          </div>
          <div className="grid justify-end items-center">
            {policy?.qualityCheck && policy?.kypPdfUrl && ["PAID", "WAIVEOFF"].includes(policy?.kypPaymentStatus) && (
              <div
                className="cursor-pointer bg-white rounded-md shadow-sm hover:bg-gray-100 transition-colors lg:mt-4 "
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(policy?.kypPdfUrl);
                }}
              >
                <img src={pdfDownloadBtn} alt="Download PDF" />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
